var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3957 12.3509C12.1417 12.3509 13.5571 10.9637 13.5571 9.25249C13.5571 7.54127 12.1417 6.15405 10.3957 6.15405C8.64975 6.15405 7.23438 7.54127 7.23438 9.25249C7.23438 10.9637 8.64975 12.3509 10.3957 12.3509Z",
    stroke: "#0008C3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90222 7.44514C3.89832 -1.155 16.8983 -1.14507 18.8843 7.45507C20.0495 12.5 16.8477 16.7702 14.041 19.4118C12.0043 21.3384 8.78219 21.3384 6.73542 19.4118C3.93885 16.7702 0.736985 12.49 1.90222 7.44514Z",
    stroke: "#0008C3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLogo);
export default __webpack_public_path__ + "static/media/mapLogo.d891a9838b05f10c660737459f060947.svg";
export { ForwardRef as ReactComponent };